import React, { useContext, useState } from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { GlobalState } from '../../../../GlobalState';



const Slider = () => {
  const [intervalz, setIntervalz] = useState(3000);
  const state = useContext(GlobalState);
  const [banners] = state.bannersAPI.banners;

  console.log(banners);
  const onChange = (index, item) => {
    setIntervalz(item.props["data-interval"]);
  };
  return (
    <Carousel
      onChange={onChange}
      autoPlay
      interval={intervalz}
      infiniteLoop={true}
    >
      {
        banners.map(banner => (
          <div data-interval={3000}>
            <img style={{ img: 'cover' }} alt="" src={banner.images.url} />
            <h1 className="legend">{banner.title}</h1>
          </div>
        ))
      }
    </Carousel>
  )
}

export default Slider
